interface IProps {
  text?: string;
  noBoxShadow?: boolean;
}
const IPLoadingModal = (props: IProps) => {
  const { text = 'Yükleniyor...', noBoxShadow = false } = props;

  const styles = {
    borderRadius: '0.475rem',
    boxShadow: noBoxShadow ? 'none' : '0 0 50px 0 rgb(82 63 105 / 15%)',
    backgroundColor: '#fff',
    color: '#7e8299',
    fontWeight: 500,
    margin: '0',
    width: 'auto',
    padding: '1rem 2rem',
  };

  return (
    <div style={styles} className="d-flex align-items-center">
      {' '}
      <div className="me-2 spinner-border w-15px h-15px"></div> {text}
    </div>
  );
};

export default IPLoadingModal;
